/** Сайт-визитка: покупка и allowlist проверяются на backend. */

export const WEBSITE_MODULE_PRICE_RUB = 4900;

export function isClubWebsiteAllowed(_tenantOrSubdomain) {
  return true;
}

export function isWebsiteModulePurchased(tenantOrModule) {
  if (!tenantOrModule) return false;
  if (tenantOrModule.purchased != null) return Boolean(tenantOrModule.purchased);
  if (tenantOrModule.can_edit != null) return Boolean(tenantOrModule.can_edit);
  return Boolean(tenantOrModule.website_purchased_at);
}

export function formatPriceRub(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("ru-RU")} ₽`;
}
